import { render, staticRenderFns } from "./AmbitEspecificCrud.vue?vue&type=template&id=8d112884&scoped=true&"
import script from "./AmbitEspecificCrud.vue?vue&type=script&lang=js&"
export * from "./AmbitEspecificCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d112884",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
